<template>
	<div class="recipe">
		<router-link :to="'/recipes/' + recipe.slug" class="image-link">
			<lazy-background :src="recipe.image_source.thumb320"></lazy-background>
		</router-link>
		<div class="content">
			<h2><router-link :to="'/recipes/' + recipe.slug">{{ recipe.name }}</router-link></h2>
			<div class="tags" v-if="recipe.tags.length > 0">
				<router-link v-for="(tag, i) in recipe.tags" :key="recipe.slug + '-' + tag.id" :to="'/recipes/tag/' + tag.slug">{{ tag.name }}</router-link>
			</div>
			<div>{{ recipe.short_description }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['value', 'ad'],
		data() {
			return {
				recipe: this.value
			};
		},
		watch: {
			value() {
				this.recipe = this.value;
			},
			recipe() {
				this.$emit('input', this.recipe);
			}
		}
	}
</script>